import { publicPostApi } from "../../utils/apiHelper";

// Deliberately separate from authAction.js -- own localStorage keys
// (adminAccessToken/adminExpireAt/adminUser), own backend collection,
// no shared session state with the regular org-user login.
export const adminLogin = (payload) => () => {
  return new Promise((resolve, reject) => {
    publicPostApi("/admin/login", payload)
      .then((response) => {
        if (response.status === 200) {
          const { accessToken, admin, expireAt } = response.data.result;
          localStorage.setItem("adminAccessToken", accessToken);
          localStorage.setItem("adminUser", JSON.stringify(admin || {}));
          localStorage.setItem("adminExpireAt", JSON.stringify(expireAt));
          resolve();
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
